import { initDycolor } from '~';

export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '',
    },
    colorInvert: {
      default: false,
    },
    badge: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      default: 'default',
    },
  },
  created() {
    initDycolor('box-widget', require(`${process.env.DYCOLOR_REQUIRE}./BoxWidget.scss`)); // eslint-disable-line
  },
  computed: {
    states() {
      return {
        default: {
          className: 'box-widget--default',
          badgeIcon: 'check',
        },
        success: {
          className: 'box-widget--success',
          badgeIcon: 'check',
        },
        error: {
          className: 'box-widget--error',
          badgeIcon: 'remove',
        },
      };
    },
    iconSizes() {
      return {
        big: {
          className: 'box-widget--icon-size-big',
          scale: 1.8,
        },
      };
    },
    iconSizeScale() {
      return this.iconSize === '' ? 0.9 : this.iconSizes[this.iconSize].scale;
    },
    currentState() {
      return this.states[this.state];
    },
    badgeIcon() {
      return this.currentState.badgeIcon;
    },
    classNames() {
      const classes = [];
      classes.push(this.currentState.className);
      if (this.colorInvert) {
        classes.push('box-widget--color-invert');
      }
      if (this.iconSize) {
        classes.push(this.iconSizes[this.iconSize].className);
      }
      return classes;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/box-widget/BoxWidget.js